import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { TokenExtension } from '@utils/extensions/token.extension.ts';

/**
 * Whether the logged-in visitor of a share link can open the session in the
 * normal editor. Shared editors redirect only then; a logged-in user from
 * another organisation (403/404) keeps the shared editor instead of landing
 * on an editor they can't load.
 */
export function useCanOpenPrivateSession(sessionId?: string) {
  const loggedIn = !!TokenExtension.get()?.string;
  const { data, isLoading } = useQuery(
    ['shared-private-access', sessionId],
    () => Axios.get(GET_URL(sessionId).session).then(() => true),
    {
      enabled: loggedIn && !!sessionId,
      retry: false,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      // A 403/404 is an expected answer here, not an error to report.
      onError: () => undefined
    }
  );
  return {
    checking: loggedIn && !!sessionId && isLoading,
    canOpen: data === true
  };
}
